import React, { FC } from 'react';

const IconRest: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 141.8 178.8"
      {...props}
    >
      <path
        id="Combined-Shape_5_"
        className="st0"
        d="M1.7,0C1.2,0.1,0.8,0.4,0.5,0.8C0.2,1.1,0,1.6,0,2.1c0,58.7,0,122.7,0,174.7
                                        c0,0.5,0.2,1.1,0.6,1.5c0.4,0.4,1,0.6,1.5,0.6h137.5c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0.1-58.4,0-116.4,0-174.7
                                        c0-0.5-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.6-1.5-0.6H2.2C2,0,1.8,0,1.7,0z M4.3,4.2h133.2v41.2H4.3V4.2z M4.3,49.5h133.2V58H4.3V49.5z
                                        M4.3,62.1h122l-122,38.4V62.1z M137.5,63v111.8H4.3v-69.9L137.5,63z M15.1,14.9L15.1,14.9h46.7c1.2,0,2.1,0.9,2.1,2V38
                                        c0,1.1-0.9,2-2.1,2H15.1c-1.2,0-2.1-0.9-2.1-2V17C13.1,15.9,14,14.9,15.1,14.9z M17.2,19v17h42.6V19H17.2z M76.7,14.9L76.7,14.9
                                        h46.7c1.2,0,2.1,0.9,2.1,2V38c0,1.1-0.9,2-2.1,2H76.7c-1.2,0-2.1-0.9-2.1-2V17C74.6,15.9,75.5,14.9,76.7,14.9z M78.8,19L78.8,19v17
                                        h42.6V19H78.8z"
      />
    </svg>
  );
};

export default IconRest;
